import { Link } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { Landmark } from "lucide-react";
import { defineModuleUi, from, unwrap, useOrg } from "@vixio/data";
import { StatusFromMap, formatDate, lazyPage } from "@vixio/ui";
import { OBLIGATION_STATE, type ObligationView } from "./api";

export * from "./api";

// Telas carregadas sob demanda: cada uma vira um arquivo à parte no build.
const GovernancePage = lazyPage(() => import("./GovernancePage"), "GovernancePage");
const MeetingPage = lazyPage(() => import("./MeetingPage"), "MeetingPage");

function ObligationsWidget() {
  const org = useOrg();
  const q = useQuery({
    queryKey: ["governance", "widget", org.id],
    queryFn: () => unwrap<ObligationView[]>(from("governance", "v_obligations").select("*").eq("org_id", org.id).eq("status", "pendente").order("due_on").limit(5)),
  });
  if (!q.data?.length) return <p className="muted">Nenhuma obrigação societária pendente.</p>;
  return (
    <ul className="vx-stack" style={{ gap: 8, margin: 0, padding: 0, listStyle: "none" }}>
      {q.data.map((o) => (
        <li key={o.id} className="vx-row vx-row--between" style={{ flexWrap: "nowrap" }}>
          <span style={{ minWidth: 0 }}>
            <Link to={`/gestao/societario?entidade=${o.entity_id}&aba=obrigacoes`}>{o.title}</Link>
            <span className="text-2 num"> · {formatDate(o.due_on)}</span>
          </span>
          <StatusFromMap map={OBLIGATION_STATE} value={o.state} />
        </li>
      ))}
    </ul>
  );
}

export default defineModuleUi({
  key: "governance",
  title: "Societário",
  domain: "governance",
  icon: Landmark,
  menu: [{ path: "/gestao/societario", label: "Societário", minRole: "manager", icon: Landmark, order: 20, keywords: "sócios quotas quadro societário assembleia reunião ata deliberação voto procuração obrigação prazo" }],
  routes: [
    { path: "/gestao/societario", element: <GovernancePage />, minRole: "manager" },
    { path: "/gestao/societario/reunioes/:id", element: <MeetingPage />, minRole: "manager" },
  ],
  widgets: [{ key: "governance.obligations", title: "Prazos societários", minRole: "manager", span: 1, order: 72, element: ObligationsWidget }],
});
